const isNotSafeInteger = (value) => (Array.isArray(value) ? true : !Number.isSafeInteger(value));

export default isNotSafeInteger;
